export const INQUIRY_FETCH = 'INQUIRY_FETCH'
export const INQUIRY_POLL = 'INQUIRY_POLL'
export const REQUIRED_DOCUMENTS_FETCH = 'REQUIRED_DOCUMENTS_FETCH'
